import React, { useState, useEffect, useRef } from "react";
import i18n from "i18next";
import Tag from '../Tag/Tag'
import Button from '../Button/Button'
import CheckboxNew from '../CheckboxNew/CheckboxNew'
import Svg from "../../assets/icons/icons"
import useDropdownPosition from "../../hooks/useDropdownPosition";
import useMultiSelectValues from "../../hooks/useMultiSelectValues";
import {
    SelectSt,
    СhosenSt,
    MediumSt,
    ArrowSt,
    ListSt,
    UlWrapSt,
    UlSt,
    ButtonWrapSt,
    SelectedLabelsSt,
    CheckboxContainerSt,
} from './style';
import { WrapperSt, ErrorWrapperSt, ErrorSt } from "../TextField/style";

// задержка перед переключением, чтобы успели отработать внешние обработчики клика
const TOGGLE_DELAY = 100;

const Select = ({
    content, primary, action, name, className, error, position, viewType,
    closeAllSelect, _closeAllSelect, updateData, handleFieldChange,
}) => {
    const [placeholder] = useState(content[0]);
    const [open, setOpen] = useState(false);

    const {
        values, tags, selectedIds, checkedAll, toggleByName, toggleAll,
    } = useMultiSelectValues(content[1]);

    // авто-позиционирование выпадающего списка
    const {
        containerRef, anchorRef, listRef, dropUp, maxHeight, anchorOffset, shiftX,
    } = useDropdownPosition({
        open,
        preferTop: position === "top",
        deps: [values],
    });

    // актуальное значение open для чтения внутри setTimeout
    const openRef = useRef(open);
    openRef.current = open;

    const toggleTimer = useRef(null);
    useEffect(() => () => clearTimeout(toggleTimer.current), []);

    // при открытии другого селекта закрываем текущий
    const prevCloseAllSelect = useRef(closeAllSelect);
    useEffect(() => {
        if (closeAllSelect !== prevCloseAllSelect.current && openRef.current) {
            setOpen(false);
        }
        prevCloseAllSelect.current = closeAllSelect;
    }, [closeAllSelect]);

    const handleOpenSelectClick = () => {
        // при открытии текущего селекта просим родителя закрыть остальные
        if (_closeAllSelect && !openRef.current) _closeAllSelect();
        clearTimeout(toggleTimer.current);
        toggleTimer.current = setTimeout(() => setOpen(prev => !prev), TOGGLE_DELAY);
    };

    const handleRemoveTag = (e) => {
        e.preventDefault();
        toggleByName(e.target.parentNode.getAttribute("data-value"));
    };

    const label = tags.length === 0 ? placeholder : tags.join(', ');
    const labelSelectAll = i18n.t(`login.select_all`) || 'Выбрать все';

    return (
        <SelectSt ref={containerRef}>
            <WrapperSt>
                <СhosenSt
                    ref={anchorRef}
                    className={className + ' chosenStyled'}
                    name={name}
                    onClick={handleOpenSelectClick}
                    open={open}
                    action={action}
                    primary={primary}
                >
                    <MediumSt>{label}</MediumSt>
                    <ArrowSt open={open}>
                        <Svg
                            className={open ? "keyboard_arrow_top" : ""}
                            type="keyboard_arrow"
                        />
                    </ArrowSt>
                </СhosenSt>
                <ErrorWrapperSt>
                    <ErrorSt>{error}</ErrorSt>
                </ErrorWrapperSt>
            </WrapperSt>

            <ListSt
                ref={listRef}
                position={position}
                viewType={viewType}
                open={open}
                dropUp={dropUp}
                maxHeight={maxHeight}
                anchorOffset={anchorOffset}
                shiftX={shiftX}
            >
                {tags.length > 0 && (
                    <SelectedLabelsSt>
                        {tags.map(tag => (
                            <Tag
                                key={tag}
                                removeTag={handleRemoveTag}
                                name={tag}
                                value={tag}
                            />
                        ))}
                    </SelectedLabelsSt>
                )}

                <UlWrapSt>
                    <UlSt>
                        <CheckboxContainerSt>
                            <div className="CheckboxContainerSt" onClick={toggleAll}>
                                <CheckboxNew label={labelSelectAll} checked={checkedAll} />
                            </div>
                        </CheckboxContainerSt>

                        {values.map(item => (
                            <CheckboxContainerSt key={item.id ?? item.name}>
                                <div
                                    className="checkboxContainer"
                                    onClick={() => toggleByName(item.name)}
                                >
                                    <CheckboxNew
                                        label={item.name}
                                        checked={item.checked}
                                    />
                                </div>
                            </CheckboxContainerSt>
                        ))}
                    </UlSt>
                </UlWrapSt>

                <ButtonWrapSt onClick={() => updateData(values, name)} open={open}>
                    <Button label="ок" size="medium" width="340px" name={name} />
                </ButtonWrapSt>
            </ListSt>

            <input
                onChange={handleFieldChange}
                type="hidden"
                name={name}
                value={selectedIds}
            />
        </SelectSt>
    )
};

export default Select;
